import { styled } from '@mui/material';

import { useState } from 'react';

import { Typography, Box } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

import { ArrowDownIcon } from '@app-velocity/icons';

import { useReportContext } from '../../../../../../context/useReportContext';

const StyledLabel = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  lineHeight: 1.5,
  fontWeight: 400,
}));

const StyledPrompt = styled(Typography)({
  fontSize: 16,
  lineHeight: 1.5,
  fontWeight: 300,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

const PromptContainer = styled('div')(({ theme }) => ({
  padding: `${theme.spacing(1)} 0`,

  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

const RotatedArrow = styled('div')({
  transform: 'rotate(180deg)',
  transformOrigin: '50% 50%',
  display: 'flex',
});

const ExpandButton = styled('button')(({ theme }) => ({
  padding: theme.spacing(2),
  textAlign: 'center',
  cursor: 'pointer',
  border: 'none',
  background: 'transparent',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  svg: {
    fill: 'var(--icon-icon-secondary-color)',
    stroke: 1,
    height: theme.spacing(4),
    width: theme.spacing(4),
  },
}));

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(4),
  alignItems: 'flex-start',
}));

const DescriptionContainer = styled(Box)(({ theme }) => ({
  flex: '0 0 80%',
}));

export const ChallengePrompt = () => {
  const { t } = useI18n();
  const { data } = useReportContext();
  const [expanded, setExpanded] = useState(false);

  const toggle = () => {
    setExpanded((prev) => !prev);
  };

  if (!data?.challenge) return null;

  const expandable = data?.challenge?.length > 120;
  const sliced =
    !expandable || expanded
      ? data?.challenge
      : `${data?.challenge?.slice(0, 120)}...`;

  const arrowIcon = expanded ? (
    <ArrowDownIcon />
  ) : (
    <RotatedArrow>
      <ArrowDownIcon />
    </RotatedArrow>
  );

  return (
    <DescriptionContainer>
      <StyledLabel>{t('reports:task_description')}</StyledLabel>
      <StyledBox>
        <PromptContainer>
          <StyledPrompt>{sliced}</StyledPrompt>
        </PromptContainer>
        {expandable ? (
          <ExpandButton onClick={toggle}>{arrowIcon}</ExpandButton>
        ) : null}
      </StyledBox>
    </DescriptionContainer>
  );
};
